module.exports = __webpack_public_path__ + "img/Bronze.0a4a207a.png";